/**
 * Loading skeleton for the Statistics Trend Chart section.
 * Used by CompanyStatisticsPage and StatisticsOverviewPage.
 */

import React from 'react';
import { Paper, Skeleton } from '@mui/material';

const StatsChartSkeleton: React.FC = () => (
  <Paper sx={{ p: 3, mb: 3 }}>
    <Skeleton variant="text" width={180} sx={{ fontSize: '1.25rem', mb: 2 }} />
    <Skeleton variant="rounded" width="100%" height={350} />
  </Paper>
);

export default StatsChartSkeleton;
